/**
 * Presence — répartition géographique des églises francophones.
 */
import { colors, fonts, goldGradient } from "../../styles/tokens";
import useScrollFadeIn from "../../hooks/useScrollFadeIn";

const REGIONS = [
  { flags: "🇨🇮🇨🇲🇨🇩", label: "Afrique subsaharienne", count: "~220 000 églises" },
  { flags: "🇫🇷",       label: "France & DOM-TOM",      count: "~45 000 églises" },
  { flags: "🇧🇪🇨🇭",    label: "Belgique · Suisse",    count: "~18 000 églises" },
  { flags: "🇨🇦🇭🇹",    label: "Canada · Haïti",        count: "~22 000 églises" },
  { flags: "🌐",        label: "Reste du monde",        count: "~95 000 églises" },
];

export default function Presence() {
  const [titleRef, titleStyle] = useScrollFadeIn();
  const [totalRef, totalStyle] = useScrollFadeIn({ delay: 400 });

  return (
    <section style={{
      padding: "clamp(64px, 10vw, 100px) clamp(16px, 4vw, 24px)",
      background: colors.surface, fontFamily: fonts.body,
      maxWidth: "100vw", overflowX: "hidden",
    }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <h2 ref={titleRef} style={{
          ...titleStyle,
          fontFamily: fonts.heading,
          fontSize: "clamp(32px, 4vw, 48px)",
          fontWeight: 700,
          textAlign: "center",
          color: colors.text,
          marginBottom: "12px",
          letterSpacing: "-0.01em",
        }}>
          Partout où l'on prie<br />
          <span style={{ color: colors.gold }}>en français.</span>
        </h2>
        <p style={{
          textAlign: "center", color: colors.textMuted, fontSize: "16px",
          maxWidth: 600, margin: "0 auto 48px", lineHeight: 1.6,
        }}>
          Mon Ministère est conçu pour la diaspora et les terres francophones.
        </p>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "16px",
          marginBottom: "48px",
        }}>
          {REGIONS.map((r, i) => (
            <Region key={r.label} item={r} delay={i * 80} />
          ))}
        </div>

        <div ref={totalRef} style={{
          ...totalStyle,
          textAlign: "center",
          padding: "32px 24px",
          background: `linear-gradient(135deg, ${colors.goldDim} 0%, ${colors.card} 100%)`,
          border: `1px solid ${colors.goldBorder}`,
          borderRadius: "16px",
        }}>
          <div style={{
            fontFamily: fonts.heading,
            fontSize: "clamp(24px, 3vw, 32px)",
            fontWeight: 700,
            color: colors.text,
            letterSpacing: "-0.01em",
          }}>
            <span style={{
              background: goldGradient,
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}>
              400 000 communautés
            </span>{" "}
            ·{" "}
            <span style={{
              background: goldGradient,
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}>
              88 pays
            </span>{" "}
            · <span style={{ color: colors.text }}>1 seule app</span>
          </div>
        </div>
      </div>
    </section>
  );
}

function Region({ item, delay }) {
  const [ref, style] = useScrollFadeIn({ delay });
  return (
    <div ref={ref} style={{
      ...style,
      padding: "20px 18px",
      background: colors.card,
      border: `1px solid ${colors.border}`,
      borderRadius: "14px",
      textAlign: "center",
    }}>
      <div style={{ fontSize: "32px", marginBottom: "8px" }}>{item.flags}</div>
      <div style={{ color: colors.text, fontWeight: 600, fontSize: "14px", marginBottom: "4px" }}>
        {item.label}
      </div>
      <div style={{ color: colors.gold, fontSize: "13px" }}>
        {item.count}
      </div>
    </div>
  );
}
